module.exports = __webpack_public_path__ + "static/media/default-avatar.f32b5563.png";